<template>
  <div class="carousel__stack-item">
    <!-- กล่องด้านหลัง -->

    <div class="carousel__stack-overlay">
      <b-img :src="layerCardSvg" class="thumbnail-overlay__img overlay-image" />
    </div>
    <!-- <div class="overlay-image-container">
      <div class="overlay-image">

      </div>
    </div> -->
    <div class="stack__card">
      <!-- รูปภาพด้านบน -->
      <div class="stack__thumbnail-header">
        <base-presigned-image
          class="stack__thumbnail-img"
          :file-id="item.image.id"
          :default-src="item.image.id ? item.image.url : defaultCoverImage"
          public
        >
        </base-presigned-image>

        <div class="badge__stack-overlay">
          <svg
            class="icon__stack-set"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="rgba(60,68,177,1)"
          >
            <path
              d="M20.0833 15.1999L21.2854 15.9212C21.5221 16.0633 21.5989 16.3704 21.4569 16.6072C21.4146 16.6776 21.3557 16.7365 21.2854 16.7787L12.5144 22.0412C12.1977 22.2313 11.8021 22.2313 11.4854 22.0412L2.71451 16.7787C2.47772 16.6366 2.40093 16.3295 2.54301 16.0927C2.58523 16.0223 2.64413 15.9634 2.71451 15.9212L3.9166 15.1999L11.9999 20.0499L20.0833 15.1999ZM20.0833 10.4999L21.2854 11.2212C21.5221 11.3633 21.5989 11.6704 21.4569 11.9072C21.4146 11.9776 21.3557 12.0365 21.2854 12.0787L11.9999 17.6499L2.71451 12.0787C2.47772 11.9366 2.40093 11.6295 2.54301 11.3927C2.58523 11.3223 2.64413 11.2634 2.71451 11.2212L3.9166 10.4999L11.9999 15.3499L20.0833 10.4999ZM12.5144 1.30864L21.2854 6.5712C21.5221 6.71327 21.5989 7.0204 21.4569 7.25719C21.4146 7.32757 21.3557 7.38647 21.2854 7.42869L11.9999 12.9999L2.71451 7.42869C2.47772 7.28662 2.40093 6.97949 2.54301 6.7427C2.58523 6.67232 2.64413 6.61343 2.71451 6.5712L11.4854 1.30864C11.8021 1.11864 12.1977 1.11864 12.5144 1.30864ZM11.9999 3.33233L5.88723 6.99995L11.9999 10.6676L18.1126 6.99995L11.9999 3.33233Z"
            ></path>
          </svg>
          <span>Skill set packages</span>
        </div>
      </div>

      <!-- Content -->
      <div class="stack__content">
        <div class="stack-content__body">
          <vue-show-more-text
            class="text__stack-name text__title h-100 p-0 text-black"
            :lines="2"
            :text="item.title"
            more-text=""
          >
          </vue-show-more-text>

          <vue-show-more-text
            class="text__stack-description text__description h-100 p-0 text-black"
            :lines="3" 
            :text="item.description"
            more-text=""
          ></vue-show-more-text>
        </div>

        <!-- Footer -->
        <div class="stack-content__footer what-will-you-get text-black">
          <p class="m-0">What will you get ?</p>

          <!-- CAREER_SPECIFIC -->
          <div class="icon__stack-footer">
            <div v-show="item.level_types.includes('CAREER_SPECIFIC')" class="icon__stack-details">
              <b-img class="icon__stack" :src="iconBadgeSvg" />
              <span>Digital Badge</span>
            </div>

            <!-- ACADEMIC_FOCUS -->
            <div v-show="item.level_types.includes('ACADEMIC_FOCUS')" class="icon__stack-details">
              <b-img class="icon__stack" :src="iconCertificateSvg" />
              <span>Digital Certificate</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BasePresignedImage from '@/components/base-components/BasePresignedImage.vue';
import vueShowMoreText from 'vue-show-more-text';

import iconBadgeSvg from '@/assets/stack-card/icon-badge.svg';
import iconCertificateSvg from '@/assets/stack-card/icon-certificate.svg';
import defaultCoverImage from '@/assets/default-lu-cover.jpg';
import layerCardSvg from '@/assets/stack-card/layer-card.svg';

export default {
  components: {
    BasePresignedImage,
    vueShowMoreText
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      iconBadgeSvg,
      iconCertificateSvg,
      defaultCoverImage,
      layerCardSvg
    };
  },
};
</script>

<style lang="scss" scoped>
::v-deep .anchor {
  display: none;
}
.stack__card {
  display: flex;
  flex-direction: column;
  flex: 1;
  margin: 0 4px;
}
.carousel__stack-item {
  background: #ffffff;
  color: #070919;
  border-radius: 10px;
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: transparent;
}
.carousel__stack-overlay {
  margin-bottom: -14px;
  position: relative;
  width: 100%;
  object-fit: cover;
}
.stack__thumbnail-header {
  position: relative;
  aspect-ratio: 9/6 auto; // fixed aspect ratio
  overflow: hidden;
}

.stack__content {
  padding: 8px;
  border: 1px solid #d1d2db;
  border-top: none;
  height: 100%;
  border-radius: 0 0 12px 12px;
  display: flex;
  flex-direction: column;
  flex: 1;
  background: #ffffff;
  line-height: 16px;
}

.text__stack-name {
  font-size: 14px;
  font-weight: 500;
}

.text__stack-description {
  font-size: 12px;
  color: rgba(7, 9, 25, 0.5);
}
.badge__stack-overlay {
  padding: 0 4px;
  color: #3c44b1;
  background-color: #ffffff;
  font-weight: 700;
  position: absolute;
  bottom: 8px;
  left: 8px;
  z-index: 1;
  border-radius: 4px;

  .icon__stack-set {
    width: 10px;
    margin-right: 4px;
  }

  span {
    font-size: 10px;
  }
}

.icon__stack-footer {
  gap: 8px;
  color: rgba(7, 9, 25, 0.5);
  font-size: 16px;

  .icon__stack-details {
    display: flex;
    align-items: center;
    flex-direction: row;
    font-size: 10px;
    margin-top: 4px;
  }

  .icon__stack {
    width: 12px;
    height: 12px;
    margin-right: 4px;
  }
}

.stack-content__body {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  gap: 8px;
  margin-bottom: 8px;
  min-height: 112px;
}

.stack-content__footer {
  height: 62px;
  border-top: 1px solid #d1d2db;
  padding-top: 8px;

  p {
    font-size: 12px;
  }
}
// .overlay-image-container {
//   position: absolute;
//   // width: 100%;
//   // height: 50px;
//   overflow: hidden;
// }
.overlay-image {
  min-height: 30px;
  width: 100%;
}

@media screen and (min-width: 768px) {
  .badge__stack-overlay {
    padding: 6px 8px;
    .icon__stack-set {
      width: 18px;
    }
    span {
      font-size: 16px;
    }
  }

  .stack__content {
    padding: 20px;
    line-height: 24px;
  }
  .stack-content__body{
    min-height: 140px;
  }

  .text__stack-name {
    font-size: 20px;
  }

  .text__stack-description {
    font-size: 16px;
  }

  .stack-content__footer {
    height: 100px;
    padding-top: 16px;

    p {
      font-size: 16px;
    }
  }

  .icon__stack-footer {
    .icon__stack-details {
      line-height: 16px;
      font-size: 16px;
      margin-top: 8px;
    }

    .icon__stack {
      width: 18px;
      height: 18px;
      margin-right: 8px;
    }
  }
}
</style>
